module.exports = __webpack_public_path__ + "static/img/image.a2e49234.png";